/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl, ValidatorFn } from '@angular/forms'
import { parsePhoneNumber } from 'awesome-phonenumber'

export function countryPrefixValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) {
      // required validator kicks in
      return null
    }

    const phoneNumber = parsePhoneNumber(control.value)
    // for some reason the phoneNumber has 2 members, a and b ...
    if (!phoneNumber.possible) {
      return { countryPrefix: true }
    }

    return null
  }
}
